import { createSlice } from '@reduxjs/toolkit';

interface G2State {
  isPromptVisible: boolean;
}

const initialState: G2State = {
  isPromptVisible: false,
};

const G2Slice = createSlice({
  name: 'g2',
  initialState,
  reducers: {
    show: (state) => {
      state.isPromptVisible = true;
    },
    hide: (state) => {
      state.isPromptVisible = false;
    },
  },
});

export const { show: showG2Prompt, hide: hideG2Prompt } = G2Slice.actions;
export default G2Slice.reducer;
